/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @preferred
 * @module ServiceEngineGroupModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { VIPModule } from '@vmw/ngx-vip';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { seGroupCollectionProvider } from './ajs-upgraded-providers';

import {
    SEGroupListExpanderComponent,
} from './components/se-group-list-expander/se-group-list-expander.component';

import {
    SEGroupListPageComponent,
} from './components/se-group-list-page/se-group-list-page.component';

const seGroupComponents = [
    SEGroupListExpanderComponent,
    SEGroupListPageComponent,
];

@NgModule({
    declarations: [
        ...seGroupComponents,
    ],
    imports: [
        AviFormsModule,
        BrowserAnimationsModule,
        CommonModule,
        DataGridModule,
        SharedModule,
        VIPModule,
    ],
    providers: [
        seGroupCollectionProvider,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
})
export class ServiceEngineGroupModule {}
